import { render, staticRenderFns } from "./Setup_SupplierTypesN.vue?vue&type=template&id=27ec60f6&"
import script from "./Setup_SupplierTypesN.vue?vue&type=script&lang=js&"
export * from "./Setup_SupplierTypesN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports